<template>
  <CCardBody>
    <ul class="py-1">
      <li class="d-flex justify-content-between font-weight-bold text-gray-800">
        <span :class="{ 'font-xl': isSummary }" class="text-capitalize">
          {{ $t(`manageplan.component.card.plan.${planName.toLowerCase()}`) }}
          <CBadge v-if="planName == 'professional'" class="text-uppercase bg-gray-200 text-gray-500 px-2 py-1 font-xs ml-2">
            {{ $t(`manageplan.component.card.plan.recomended`) }}</CBadge
          >
        </span>
        <span v-if="!isSummary">{{ mount ? formatNumber(mount) : '' }} € / {{ $t(`manageplan.component.card.plan.period.${period}`) }}</span>
        <a v-else href="" class="font-weight-normal">
          {{ $t(`manageplan.component.card.plan.edit`) }}
        </a>
      </li>
      <li class="d-flex justify-content-between">
        <span class="font-weight-bold text-gray-800">{{ contacts }} {{ $t(`manageplan.component.card.plan.contacts`) }}</span>
        <span>
          <CIcon name="users" :height="25" viewBox="0 0 32 32" size="custom-size" class="mr-2 text-gray-800" />
        </span>
      </li>
      <li class="d-flex justify-content-between">
        <span class="font-weight-bold text-gray-800">{{ emails }} {{ $t(`manageplan.component.card.plan.emails`) }}</span>
        <span>
          <CIcon name="emailNew" :height="20" viewBox="0 0 39 32" class="mr-2 text-gray-800" />
        </span>
      </li>
      <!-- <li class="d-flex justify-content-between">
        <span>
          <a href="#" @click.prevent="prev" v-if="!isSummary"> {{ $t(`manageplan.component.card.plan.changePlan`) }}</a>
          <a href="" v-else>{{ $t(`manageplan.component.card.plan.viewDetails`) }}</a>
        </span>
      </li> -->
    </ul>
  </CCardBody>
</template>

<script>
import { currencyFormat, currencyFormatStyleEnum } from '@/utils/numbersFormatUtil.js'

export default {
  name: 'CardPlan',
  computed: {
    isSummary() {
      return this.place == 'summary'
    },
    planName() {
      return this.$store.state.backOffice.steps.selectedPlanName.toLowerCase()
    },
    mount() {
      // paymentPeriod = 3 é anual
      return this.period == 3
        ? (this.$store.state.backOffice.steps.mount * 12).toFixed(2)
        : parseFloat(this.$store.state.backOffice.steps.mount).toFixed(2)
    },
    emails() {
      return this.$store.state.backOffice.steps.maxEmailsIncluded
    },
    contacts() {
      return this.$store.state.backOffice.steps.maxAudience
    },
    period() {
      return this.$store.state.backOffice.steps.paymentPeriod
    },
  },
  methods: {
    formatNumber(number) {
      return currencyFormat(number, currencyFormatStyleEnum.DECIMAL)
    },

    prev() {
      this.$store.dispatch('backOffice/steps/setCurrentStep', 1)
    },

    applyDiscount(value) {
      if (this.period == 3) {
        let discount = value * 0.1
        let newValue = value - discount
        return newValue.toFixed(1)
      }

      return value
    },
  },
}
</script>

<style lang="scss"></style>
